import React from 'react'
import Image from 'components/shared/Image'
import Layout from 'components/shared/Layout'
import LabelTitleText from 'components/shared/LabelTitleText'
import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const TextSlice = ({
  className,
  titleProps,
  textProps,
  linkProps,
  alignCenter,
  withBackground,
  content,
  layout,
}) => {
  return (
    <Layout type="maxWidth" className={className}>
      <Layout type="wrapper">
        <div className={cx(css.TextSlice, layout)}>
          {withBackground && (
            <Image
              className={css.backgroundContainer}
              layout="fill"
              local
              src="/assets/text-slice-pattern.png"
              objectFit="cover"
            />
          )}
          {content && (
            <LabelTitleText
              center={alignCenter}
              labelProps={{
                ...(content?.theme === 'darkMode' && { theme: 'purple' }),
                ...(layout === 'large' && {
                  className: css.labelLarge,
                }),
              }}
              titleProps={{
                ...titleProps,
                ...((withBackground || content?.theme === 'darkMode') && {
                  theme: 'white',
                }),
              }}
              textProps={{
                ...textProps,
                ...(withBackground && {
                  theme: 'white',
                }),
                ...(content?.theme === 'darkMode' && {
                  theme: 'grey-400',
                }),
                ...(layout === 'large' && {
                  className: css.textLarge,
                }),
              }}
              linkProps={linkProps}
              buttonProps={{
                ...(layout === 'large' && { className: css.smallButton }),
              }}
              {...content}
            />
          )}
        </div>
      </Layout>
    </Layout>
  )
}

TextSlice.defaultProps = {
  titleProps: { size: 'medium' },
  textProps: { size: 'big' },
  linkProps: { size: 'big' },
}

export default TextSlice
